export default "__VITE_ASSET__Dk9md9JC__"